import { OTAMetadata } from './types';

export const useOTAMetadata = (): OTAMetadata => {
  return {
    is_embedded_update: false,
    ota_update_id: null,
    ota_update_created_at: null,
  };
};
